import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import CheckInPage from './pages/CheckInPage';
import ReflectiveChatPage from './pages/ReflectiveChatPage';
import CBTPage from './pages/CBTPage';
import InsightsPage from './pages/InsightsPage';
import AboutPage from './pages/AboutPage';
import { useCheckIn } from './hooks/useCheckIn';

function App() {
  const { response, loading, history, formData, submitCheckIn, updateFormData, reset } = useCheckIn();

  const handleFormChange = (field, value) => {
    updateFormData(field, value);
  };

  const handleSubmit = (data) => {
    submitCheckIn(data);
  };

  const handleReset = () => {
    reset();
  };

  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/check-in"
          element={
            <CheckInPage
              formData={formData}
              onUpdateForm={handleFormChange}
              onSubmit={handleSubmit}
              response={response}
              loading={loading}
              onReset={handleReset}
            />
          }
        />
        <Route path="/reflective-chat" element={<ReflectiveChatPage />} />
        <Route path="/cbt-tools" element={<CBTPage />} />
        <Route path="/insights" element={<InsightsPage history={history} />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
    </Router>
  );
}

export default App;
